export type TeamSize = '1-5' | '6-10' | '11-20' | '21-50' | '50+';

export type ServiceType = 
  | 'spa'
  | 'salon'
  | 'nail'
  | 'massage'
  | 'cleaning'
  | 'repair'
  | 'haircut'
  | 'gym'
  | 'makeup'
  | 'food'
  | 'other';

export type PackageType = 'free' | 'premium';

export interface PartnerFormData {
  // Firestore document ID
  id?: string;

  // Step 1: Account
  email: string;
  password: string;
  confirmPassword: string;

  // Step 2: Business Info
  businessName: string;
  website: string;

  // Step 3: Services
  services: ServiceType[];

  // Step 4: Team Size
  teamSize: TeamSize;

  // Step 5: Address
  address: string;
  hasNoFixedAddress: boolean;
  latitude?: number;
  longitude?: number;
  
  // Step 6: Package
  selectedPackage: PackageType;

  // Metadata
  createdAt: Date;
  status: 'pending' | 'approved' | 'rejected';
}

export const SERVICE_OPTIONS = [
  { value: 'spa', label: 'Spa & chăm sóc da' },
  { value: 'salon', label: 'Salon tóc' },
  { value: 'nail', label: 'Nail & mi' },
  { value: 'massage', label: 'Massage tại nhà' },
  { value: 'cleaning', label: 'Dọn dẹp nhà cửa' },
  { value: 'repair', label: 'Sửa chữa điện nước' },
  { value: 'haircut', label: 'Cắt tóc nam tại nhà' },
  { value: 'gym', label: 'Gym & huấn luyện viên' },
  { value: 'makeup', label: 'Tư vấn trang điểm cô dâu' },
  { value: 'food', label: 'Giao đồ ăn' },
  { value: 'other', label: 'Khác' }
];

export const TEAM_SIZE_OPTIONS = [
  { value: '1-5', label: '1-5 người' },
  { value: '6-10', label: '6-10 người' },
  { value: '11-20', label: '11-20 người' },
  { value: '21-50', label: '21-50 người' },
  { value: '50+', label: '50+ người' }
]; 